import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function HotspotView({ image, alt, hotspots, eyebrow = "Touch to reveal", testid = "hotspot-view" }) {
  const [active, setActive] = useState(null);

  return (
    <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0a0a0e]" data-testid={testid}>
      <img src={image} alt={alt} className="block w-full select-none object-cover" draggable="false" />

      <div className="pointer-events-none absolute left-1/2 top-4 z-10 -translate-x-1/2 rounded-full border border-[#e6b800]/40 bg-black/60 px-4 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#e6b800] backdrop-blur-sm" data-testid={`${testid}-hint`}>
        {active ? "और points touch करें" : `✦ ${eyebrow}`}
      </div>

      {hotspots.map((h) => (
        <button
          key={h.id}
          onClick={() => setActive(active === h.id ? null : h.id)}
          data-testid={`hotspot-${h.id}`}
          aria-label={h.title}
          className="absolute z-10 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center"
          style={{ left: `${h.x}%`, top: `${h.y}%` }}
        >
          <span className="absolute h-full w-full animate-ping rounded-full bg-[#e6b800]/35" style={{ animationDuration: "2.2s" }} />
          <span className={`relative flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#0a0a0e] transition-all duration-200 ${active === h.id ? "scale-110 bg-[#e6b800]" : "bg-[#e6b800]/75"}`} />
        </button>
      ))}

      <AnimatePresence>
        {active &&
          (() => {
            const h = hotspots.find((x) => x.id === active);
            const flipX = h.x > 52;
            return (
              <div
                className="absolute z-20"
                style={{ left: `${h.x}%`, top: `${h.y}%`, transform: `translate(${flipX ? "-104%" : "4%"}, -50%)` }}
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.94 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.96 }}
                  transition={{ duration: 0.22 }}
                  className="w-60 rounded-2xl border border-[#e6b800]/30 bg-[#0a0a0e]/95 p-5 shadow-[0_10px_40px_rgba(0,0,0,0.6)] backdrop-blur-md"
                  data-testid={`hotspot-card-${h.id}`}
                >
                  <button
                    onClick={() => setActive(null)}
                    className="absolute right-2.5 top-2.5 text-neutral-500 transition-colors hover:text-white"
                    aria-label="Close"
                    data-testid={`hotspot-close-${h.id}`}
                  >
                    <X size={14} />
                  </button>
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#e6b800]">{h.tag || "Feature"}</p>
                  <p className="mt-1.5 font-display text-sm font-bold text-white">{h.title}</p>
                  <p className="mt-1.5 text-[11px] leading-relaxed text-neutral-400">{h.desc}</p>
                </motion.div>
              </div>
            );
          })()}
      </AnimatePresence>
    </div>
  );
}
